module.exports = __webpack_public_path__ + "assets/img/Future_002.581fb810-ps.jpg";